import { API, graphqlOperation } from "aws-amplify";
import { GraphQLResult } from "@aws-amplify/api";
import { updateLLMGroup } from "../graphql/mutations";
import {
  UpdateLLMGroupInput,
  UpdateLLMGroupMutation,
} from "../API";

export async function updateLLMGroupAfterEdit(
  values: UpdateLLMGroupInput
): Promise<GraphQLResult<UpdateLLMGroupMutation>> {
  return API.graphql(
    graphqlOperation(updateLLMGroup, {
      input: {
        id: values.id,
        name: values.name,
        status: values.status,
        description: values.description || "",
        systemInstructions: values.systemInstructions || "",
        systemInstructionsAction: values.systemInstructionsAction || "",
        order: values.order || 0,
      },
    })
  ) as Promise<GraphQLResult<UpdateLLMGroupMutation>>;
}
